import type { ChatMessage } from "../../pages/loom/types";

/** One line per executed tool call, from the stored tool row: the tool, and how it went. */
export function toolRowSummary(m: ChatMessage): string {
  try {
    const row = JSON.parse(m.content) as { tool?: string; error?: string; result?: unknown };
    const tool = row.tool ?? "tool";
    if (typeof row.error === "string") return `${tool}: refused — ${row.error.slice(0, 160)}`;
    const result = row.result as
      | {
          ok?: boolean;
          diagnostics?: { line?: number; message?: string }[];
          errors?: { filename?: string; message?: string }[];
          draft_revision_uid?: string;
        }
      | undefined;
    if (result && result.ok === false) {
      const diag = result.diagnostics?.[0];
      if (diag) return `${tool}: did not compile — line ${diag.line}: ${String(diag.message).slice(0, 140)}`;
      const err = result.errors?.[0];
      if (err) return `${tool}: did not compile — ${err.filename ? `${err.filename}: ` : ""}${String(err.message).slice(0, 140)}`;
      return `${tool}: did not compile`;
    }
    if (result && result.ok === true) return result.draft_revision_uid ? `${tool}: written to your draft` : `${tool}: saved`;
    return tool;
  } catch {
    return "tool";
  }
}
